import React, { useRef, useState } from "react";
import { brands } from "../../../constants/brands";
import { arrowRight, mapCar } from "../../../assets/images";
import { carMarket } from "../../../constants/carMarket";
import { testimonials } from "../../../constants/testimonial";
import { latestNews } from "../../../constants/latestNews";
import { FAQ } from "../../../constants/faq";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";

import {
  Car,
  FAQS,
  HostorLesee,
  Testimonial,
  LatestNews,
  DownloadApp,
} from "../..";
import { Link } from "react-router-dom";
import { GET_CARS } from "../../../apollo/operations";
import { useQuery } from "@apollo/client";
import { VehicleType } from "../../../types";

const Options: React.FC = () => {
  const [showFaq, setShowFaq] = useState(0);
  const [vehicles, setVehicles] = useState<VehicleType[]>();

  const containerRef = useRef<HTMLDivElement>(null);

  // const handleScroll = (direction: "left" | "right") => {
  //   if (containerRef.current) {
  //     containerRef.current.scrollLeft += direction === "right" ? 300 : -300;
  //   }
  // };
  const handleScroll = (direction: "left" | "right") => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        left:
          containerRef.current.scrollLeft +
          (direction === "right" ? 300 : -300),
        behavior: "smooth",
      });
    }
  };

  const { data } = useQuery(GET_CARS, {
    variables: {
      take: 15,
      where: {
        web3Data: {
          isSet: true,
        },
      },
    },
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      if (data?.cars) {
        const result = data?.cars.reduce(
          (acc: VehicleType[], current: VehicleType) => {
            const isExist = acc.find((item) => item.make === current.make);
            if (!isExist) {
              acc.push(current);
            }
            return acc;
          },
          []
        );

        // console.log(result);
        setVehicles(result);
      }
    },
  });
  return (
    <div className="w-full  flex flex-col mt-[109px] pb-[178px] gap-20 mx-auto">
      {/* CAR BRAND LOGOS */}
      <div className="flex container  w-[90%] md:w-4/5 gap-[26px] items-center mx-auto">
        {brands.map((brand, index) => {
          return (
            <div
              className="flex w-full justify-center items-center gap-[26px] "
              key={index}
            >
              <img src={brand} alt="" />
            </div>
          );
        })}
      </div>
      {/* ARE YOU A HOST OR A LESEE */}
      <HostorLesee />
      {/* CAR MAP LOCATION */}
      <div className="w-4/5 container flex flex-col mx-auto mt-10 md:mt-60">
        <div className="text-center mx-auto">
          <h2 className="text-darkText font-Poppins text-[12px] md:text-[20px] font-bold md:font-medium uppercase text-center ">
            We offer the best services in these regions
          </h2>
          <Link
            to="/vehicles"
            className="text-[#18428C] cursor-pointer text-center font-Poppins text-[10px] md:text-[20px] font-normal md:font-medium"
          >
            Explore our marketplace of high quality cars{" "}
          </Link>
        </div>
        <div>
          <img src={mapCar} alt="" />
        </div>
      </div>
      {/* VEHICLES FOR EVERYDAY NEED */}
      <div className="w-full container mx-auto flex flex-col gap-[60px]">
        <div>
          <h2 className="text-darkText font-Poppins text-center font-bold  text-[14px] md:text-[24px] uppercase ">
            Vehicles for your everyday need
          </h2>
        </div>
        <div className=" flex items-center gap-2 relative">
          <button
            aria-label="back-button"
            className=" flex  left-0 top-1/2 transform -translate-y-1/2 bg-white hover:bg-white rounded-full p-2 border border-midGreen"
            onClick={() => handleScroll("left")}
          >
            <BsArrowLeft className=" h-6 w-6 text-midGreen" />
          </button>
          <div
            className=" flex w-full flex-1 mx-auto overflow-x-auto gap-[15px]  no-scrollbar"
            ref={containerRef}
          >
            {vehicles &&
              vehicles.map((vehicle, index) => {
                return <Car vehicle={vehicle} key={index} />;
              })}
          </div>
          <button
            aria-label="forward-button"
            className=" flex  right-0 top-1/2 transform -translate-y-1/2 bg-white hover:bg-white rounded-full p-2 border border-midGreen"
            onClick={() => handleScroll("right")}
          >
            <BsArrowRight className=" h-6 w-6 text-midGreen" />
          </button>
        </div>
        <Link
          to={"/vehicles"}
          className="flex mx-auto gap-2 px-[24px] py-2 text-[9px] md:text-[12px] items-center   bg-white border hover:text-white hover:border-white border-darkText rounded-md cursor-pointer hover:bg-lightGreen"
        >
          Show more
          <span>
            <BsArrowRight size={20} />
            {/* <img src={arrowRight} alt="" /> */}
          </span>
        </Link>
      </div>
      {/* WHAT THEY ARE SAYING ABOUT US */}
      {/* <div className="w-full md:w-4/5 container mx-auto flex flex-col gap-8 ">
        <div className=" w-[80%] md:w-full mx-auto text-center font-Inter text-darkText font-bold md:font-medium uppercase text-[16px] md:text-[24px] md:tracking-[4px] ">
          What they are saying about us
        </div>
        <div className="w-full flex flex-nowrap overflow-x-auto mx-auto lg:flex-wrap md:justify-between gap-7 ">
          {testimonials.map((testimony, index) => {
            return (
              <Testimonial testimony={testimony} index={index} key={index} />
            );
          })}
        </div>
      </div> */}
      {/* LATEST NEWS */}
      {/* <div className="w-full md:w-4/5 container mx-auto flex flex-col gap-8">
        <div className="w-[80%] md:w-full mx-auto text-center font-Inter text-darkText font-bold md:font-medium uppercase text-[16px] md:text-[24px] md:tracking-[4px] ">
          Latest News
        </div>
        <div className="w-full flex flex-nowrap overflow-x-auto mx-auto lg:flex-wrap md:justify-between gap-7 ">
          {latestNews.map((news, index) => {
            return <LatestNews news={news} index={index} key={index} />;
          })}
        </div>
      </div> */}
      {/* DOWNLOAD APP */}
      <DownloadApp />
      {/* FAQ */}
      <div className="w-[80%] lg:w-2/5 mx-auto container flex flex-col gap-4 md:gap-[35px] ">
        <div className="font-Inter text-[#215759] text-sm uppercase font-normal text-[9px] md:text-[13px]">
          Frequently asked questions
        </div>
        <div className="text-[#263238] md:tracking-widest font-Poppins text-[29px] md:text-[47px] font-medium leading-8 md:leading-[56px] ">
          Questions you might need answers to
        </div>
        <div className="w-full">
          <div className="w-full flex flex-col gap-4 ">
            {FAQ.map((faq, index) => (
              <FAQS
                faq={faq}
                index={index}
                key={index}
                showFaq={showFaq}
                setShowFaq={setShowFaq}
              />
            ))}
          </div>
        </div>
        <div className="">
          <button className="flex gap-2 px-6 py-3 bg-white border rounded-2xl md:rounded-full items-center mx-auto">
            <div className="font-Inter text-[#0E0B3D] text-[16px] font-medium leading-8 ">
              See all
            </div>
            <img src={arrowRight} alt="" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Options;
